"use client";

import { c as _c } from "react/compiler-runtime";
import { CommentActions } from "@/components/Comment/components/thread/actions/CommentActions.component";
import { CommentContent } from "@/components/Comment/components/thread/CommentContent.component";
import { useComment } from "@/components/Comment/context/comment.context";
import { RelativePublicationDateTime } from "@/components/PublicationDateTime/components/RelativePublicationDateTime/RelativePublicationDateTime.component";
export function CommentItem() {
  const $ = _c(16);
  const {
    comment
  } = useComment();
  const t0 = `Comment by ${comment.author}`;
  let t1;
  if ($[0] !== comment.author) {
    t1 = <span className="font-semibold text-nero text-sm">{comment.author}</span>;
    $[0] = comment.author;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== comment.timestamp) {
    t2 = <RelativePublicationDateTime zonedDateTime={comment.timestamp} />;
    $[2] = comment.timestamp;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== comment.timestamp || $[5] !== t2) {
    t3 = <time className="text-dim text-xs" dateTime={comment.timestamp}>{t2}</time>;
    $[4] = comment.timestamp;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t3) {
    t4 = <header className="flex items-center justify-between">{t1}{t3}</header>;
    $[7] = t1;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex flex-col gap-3"><CommentContent /><CommentActions /></div>;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4) {
    t6 = <div className="flex grow flex-col gap-1">{t4}{t5}</div>;
    $[11] = t4;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t0 || $[14] !== t6) {
    t7 = <article aria-label={t0} className="flex gap-2">{t6}</article>;
    $[13] = t0;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}